// Media store backed by the Cache Storage API. The page (shim) writes blobs/JSON here;
// the service worker (public/sw.js) reads from the SAME named cache to serve them to
// native <video src>/<img src> tags and to axios/fetch GETs for /clips,/uploads,/logos.
//
// Cache keys are path-only (no query/hash) so `?v=…#t=…` cache-busting still matches.

export const MEDIA_CACHE = 'qlipper-media';

function keyFor(path) {
  // normalize to an absolute same-origin URL, strip query + hash
  const u = new URL(path, self.location?.origin || location.origin);
  return u.origin + u.pathname;
}

export async function putBlob(path, blob, contentType) {
  const cache = await caches.open(MEDIA_CACHE);
  const headers = { 'Content-Type': contentType || blob.type || 'application/octet-stream' };
  // Range support is added by the SW; here we just store the full body.
  await cache.put(keyFor(path), new Response(blob, { headers }));
  return path;
}

export async function putJson(path, obj) {
  const cache = await caches.open(MEDIA_CACHE);
  await cache.put(keyFor(path), new Response(JSON.stringify(obj), {
    headers: { 'Content-Type': 'application/json' },
  }));
  return path;
}

export async function getResponse(path) {
  const cache = await caches.open(MEDIA_CACHE);
  return cache.match(keyFor(path));
}

export async function getBlob(path) {
  const res = await getResponse(path);
  return res ? res.blob() : null;
}

export async function getJson(path) {
  const res = await getResponse(path);
  return res ? res.json() : null;
}

export async function clearMedia() {
  await caches.delete(MEDIA_CACHE);
}
